/**
 * Global middleware that enforces route skips for app-level shells (account
 * settings, dashboard, theme playground), Nuxt-internal routes (`/_nuxt`,
 * `/__nuxt_error`, `/api`), and the courses module.
 *
 * Note: this middleware previously also detected "is this an in-app post-detail
 * navigation?" and mutated `globalThis.__navigationContext` for the layout's
 * modal-vs-full-page decision. That responsibility has moved to the
 * `modal-navigation.client.ts` plugin, which reflects `history.state` into a
 * Vue ref via `router.afterEach` — see `composables/useModalNavigation.ts`.
 */
export default defineNuxtRouteMiddleware(to => {
  // CRITICAL: Skip app-level routes immediately to prevent infinite loops
  if (to.path === '/account' || to.path.startsWith('/account/') || to.path === '/dashboard' || to.path === '/theme-playground') {
    return
  }

  // Skip validation for certain routes
  const skipValidationRoutes = ['/404', '/error', '/_nuxt', '/api', '/__nuxt_error', '/courses']
  if (skipValidationRoutes.some(route => to.path.startsWith(route))) {
    return
  }

  // Skip validation for root routes
  if (to.path === '/' || to.path === '') {
    return
  }
})
